function makeWorkerBlob(fn) {
	return new Blob(['(' + (fun => {
		onmessage = ({ data }) => Promise.resolve().then(
			() => fun.apply(fun, data[1])
		).then(
			result => { postMessage([data[0], null, result]); },
			err => { postMessage([data[0], '' + err]); }
		);
	}) + ')(' + fn + ')'], { type: 'application/javascript' });
}

export default function coworker(fn, name = 'Coworker') {
	let count = 0, posts = {};
	const worker = new Worker(URL.createObjectURL(makeWorkerBlob(fn)), { name });

	worker.onmessage = ({ data: [id, error, dat] }) => {
		posts[id][error ? 1 : 0](error || dat);
		delete posts[id];
	};

	function sendMessage(...args) {
		return new Promise((resolve, reject) => {
			let id = 'message' + ++count;
			posts[id] = [resolve, reject];
			worker.postMessage([id, args]);
		});
	}

	function terminate() {
		if (worker && worker.terminate) {
			worker.terminate();
		}
	}

	return {
		sendMessage,
		terminate
	}
}
